var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconPremiumProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b246a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37c7f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3974",
    "data-name": "Group 3974",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6878",
    "data-name": "Path 6878",
    d: "M83.636,49.818A9.818,9.818,0,1,1,73.818,40,9.818,9.818,0,0,1,83.636,49.818Zm-4.909,0a4.909,4.909,0,1,1-4.909-4.909A4.909,4.909,0,0,1,78.727,49.818Z",
    transform: "translate(-46.818 -30.182)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6879",
    "data-name": "Path 6879",
    d: "M35,8A27,27,0,1,0,62,35,27,27,0,0,0,35,8ZM12.909,35a22.007,22.007,0,0,0,4.683,13.6A22.095,22.095,0,0,1,52.567,48.4,22.091,22.091,0,1,0,12.909,35ZM35,57.091a22,22,0,0,1-13.922-4.939,17.186,17.186,0,0,1,28.046-.167A22,22,0,0,1,35,57.091Z",
    transform: "translate(-8 -8)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPremiumProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-premium-profile.fa911c6e.svg";
export { ForwardRef as ReactComponent };